import React, { useState } from 'react';
import { useAuth } from '../Auth/Auth';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import MoonLoader from 'react-spinners/MoonLoader';
import { CubeIcon, ArrowsRightLeftIcon } from '@heroicons/react/24/outline';
import StockView from './StockView';
import MovementView from './MovementView';

const InventoryTabs = () => {
  const [activeTab, setActiveTab] = useState('stock');
  const { role, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <MoonLoader size={50} color="#3B82F6" />
      </div>
    );
  }

  if (role !== 'Finance' && role !== 'Admin' && role !== 'Procurement') {
    return navigate('/unauthorized', { replace: true });
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-cyan-50 to-indigo-50">
      <ToastContainer />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        {/* Page Header */}
        <div className="mb-4">
          <div className="flex items-center space-x-3">
            <div className="p-3 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-xl shadow-lg">
              <CubeIcon className="h-6 w-6 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-black text-gray-900">Inventory Management</h1>
              <p className="text-sm text-gray-600 mt-1">
                Manage your stock items and track all inventory movements
              </p>
            </div>
          </div>
        </div>

        {/* Modern Tabs Navigation */}
        <div className="bg-white rounded-xl shadow-lg p-1 mb-4">
          <div className="flex space-x-2">
            <button
              onClick={() => setActiveTab('stock')}
              className={`flex-1 flex items-center justify-center space-x-2 px-4 py-2.5 rounded-lg font-semibold text-sm transition-all duration-200 ${
                activeTab === 'stock'
                  ? 'bg-gradient-to-r from-blue-500 to-cyan-600 text-white shadow-md'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <CubeIcon className="h-5 w-5" />
              <span>Stock Items</span>
            </button>

            <button
              onClick={() => setActiveTab('movement')}
              className={`flex-1 flex items-center justify-center space-x-2 px-4 py-2.5 rounded-lg font-semibold text-sm transition-all duration-200 ${
                activeTab === 'movement'
                  ? 'bg-gradient-to-r from-blue-500 to-cyan-600 text-white shadow-md'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <ArrowsRightLeftIcon className="h-5 w-5" />
              <span>Movements</span>
            </button>
          </div>
        </div>

        {/* Tab Content */}
        <div>
          {activeTab === 'stock' && <StockView />}
          {activeTab === 'movement' && <MovementView />}
        </div>
      </div>
    </div>
  );
};

export default InventoryTabs;
